import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

type ImageState = 'loading' | 'loaded' | 'error';

/**
 * Question picture with a placeholder: a shimmering box of the usual picture size is shown
 * until the image has loaded (so the options below do not jump), and a fallback if it fails.
 */
@Component({
  selector: 'app-quiz-image',
  templateUrl: './quiz-image.component.html',
})
export class QuizImageComponent implements OnChanges, AfterViewInit {
  @Input({ required: true }) src!: string;
  @Input() alt = '';
  @Input() lazy = false;

  state: ImageState = 'loading';

  @ViewChild('image') private image?: ElementRef<HTMLImageElement>;

  ngOnChanges(changes: SimpleChanges) {
    // The same <img> is reused when the question changes, so start over for every new picture.
    if (changes['src'] && !changes['src'].firstChange) {
      this.state = 'loading';
    }
  }

  ngAfterViewInit() {
    // A cached or server-rendered image can finish before Angular listens for (load).
    const image = this.image?.nativeElement;
    if (image?.complete && image.naturalWidth > 0) {
      queueMicrotask(() => (this.state = 'loaded'));
    }
  }

  onLoad() {
    this.state = 'loaded';
  }

  onError() {
    this.state = 'error';
  }
}
